import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { onCall, session } from '../api/client'
import { useSpoke } from '../hooks/useSpoke'
import { install, recordApi, recordRoute } from '../lib/telemetry'

onCall.record = recordApi

// Mounts the front-end analytics once the shell is up (owner, 2026-10-08): the listeners, the route log, the batches to
// the API. Renders nothing.
export function Telemetry() {
  const spoke = useSpoke()
  const location = useLocation()
  const last = useRef<string | null>(null)
  useEffect(() => {
    install(() => (spoke ? `/api/spokes/${encodeURIComponent(spoke)}/scout/telemetry` : null), () => session.get())
  }, [spoke])
  useEffect(() => {
    const to = location.pathname + location.search
    if (last.current !== null && last.current !== to) recordRoute(last.current, to)
    last.current = to
  }, [location])
  return null
}
